<template>
  <fragment>
    <fragment v-if="!noHeaders.includes(currentPath)">
      <NavBar />
      <main>
        <section>
          <slot />
        </section>
      </main>
    </fragment>
    <slot v-else />
  </fragment>
</template>

<script>
import NavBar from '@/views/NavBar';

export default {
  components: { NavBar },
  data() {
    return { noHeaders: ['/'] };
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/colors.scss';

main {
  min-height: 100vh;
  background: $gray;
  padding: 3rem 0;
  section {
    width: 90%;
    max-width: 1080px;
    margin: auto;
    border-radius: 1rem;
    padding: 3rem;
    background: $white;
    box-shadow: 7px 7px 10px 0px rgba(0, 0, 0, 0.3);
  }
}
</style>
